"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A = void 0;

var react_1 = __importDefault(require("react"));

var router_1 = require("./router");

function A(props) {
  return react_1.default.createElement("a", __assign({}, props, {
    onClick: function onClick(event) {
      if (!props.target) {
        event.preventDefault();
        router_1.router.actions.push(props.href);
      }

      props.onClick && props.onClick(event);
    }
  }));
}

exports.A = A;